import PropTypes from 'prop-types';
import UrlShape from './UrlShape';

export const ParameterShape = PropTypes.shape({
  name: PropTypes.string,
  type: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number,
    PropTypes.arrayOf(
      PropTypes.shape({
        roleId: PropTypes.string,
        readOnly: PropTypes.bool,
      }),
    ),
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
    }),
    PropTypes.arrayOf(PropTypes.string),
  ]),
  readProtected: PropTypes.bool,
});

export default PropTypes.shape({
  name: PropTypes.string,
  url: PropTypes.string,
  method: PropTypes.string,
  fieldSet: PropTypes.string,
  params: PropTypes.arrayOf(ParameterShape),
  personalConferenceRoomUrl: UrlShape,
  checkPageExists: PropTypes.bool,
});
